import { FC, Fragment, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
// Types
import MediaTypes from 'types/MediaTypes';
import MidRollPositions from 'types/MidRollPositions';
// Models
import IQuestion from 'models/Question';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
// Actions
import { setQuestionIndex, resetQuestionStatuses } from 'store/player/playerSlice';
// Selectors
import { selectQuiz, selectQuestions } from 'store/quiz/quizSelectors';
import { selectQuestionIndex } from 'store/player/playerSelectors';
// Hooks
import useToggle from 'hooks/useToggle';
import useNavigateTo from 'hooks/useNavigateTo';
// Dialogs
import BrandVideoDialog from 'dialogs/BrandVideo.dialog';
import MidRollVideoDialog from 'dialogs/MidRollVideo.dialog';
import InterstitialImageDialog from 'dialogs/InterstitialImage.dialog';

const MediaPage:FC = () => {
  // const navigate = useNavigate();

  // const { slug } = useParams<{ slug:string }>();

  const [ searchParams ] = useSearchParams();
  const mediaType = searchParams.get('mediaType');
  const midRollPosition = searchParams.get('midRollPosition');

  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const quiz:any = useAppSelector(selectQuiz);
  const questions:IQuestion[] = useAppSelector(selectQuestions);

  const questionIndex:number | undefined = useAppSelector(selectQuestionIndex);

  const navigateTo = useNavigateTo();
  const { open:openBrandDialog, toggle:toggleBrandDialog } = useToggle();
  const { open:openAdvertDialog, toggle:toggleMidRollDialog } = useToggle();
  const { open:openInterstitialDialog, toggle:toggleInterstitialDialog } = useToggle();

  useEffect(() => {
    if ( !mediaType ){
      dispatch(setQuestionIndex(questionIndex + 1));
      dispatch(resetQuestionStatuses());
      navigateTo('question');
    }

    if ( mediaType === MediaTypes.BrandVideo ){
      toggleBrandDialog();
    }
    if ( mediaType === MediaTypes.InterstitialImage ){
      toggleInterstitialDialog();
    }
    if ( mediaType === MediaTypes.MidRollVideo ){
      toggleMidRollDialog();
    }
    // eslint-disable-next-line
  }, [mediaType]);

  const handleCloseBrandDialog = () => {
    toggleBrandDialog();
    if ( quiz.advertVideo.videoUrl && quiz.advertVideo.startQuiz ){
      toggleMidRollDialog();
    } else {
      navigateTo('countdown');
    }
  }

  const handleCloseAdvertDialog = () => {
    toggleMidRollDialog();
    if (
      mediaType === MediaTypes.BrandVideo ||
      (mediaType === MediaTypes.MidRollVideo && midRollPosition === MidRollPositions.Start)
    ){
      navigateTo('countdown');
    }
    if ( mediaType === MediaTypes.MidRollVideo && midRollPosition === MidRollPositions.Middle ){
      dispatch(setQuestionIndex(questionIndex + 1));
      dispatch(resetQuestionStatuses());
      navigateTo('question');
    }
    if ( mediaType === MediaTypes.MidRollVideo && midRollPosition === MidRollPositions.End ){
      navigateTo('register');
    }
  }

  const handleCloseInterestialDialog = () => {
    toggleInterstitialDialog();
    if ( quiz.advertVideo.videoUrl && quiz.advertVideo.midQuiz ){
      if ( questions.length < 2 ){
        dispatch(setQuestionIndex(questionIndex + 1));
        dispatch(resetQuestionStatuses());
        navigateTo('question');
      } else {
        if ( Math.ceil(questions.length/2) - 1 === questionIndex ){
          navigateTo('media', {
            mediaType: MediaTypes.MidRollVideo,
            midRollPosition: MidRollPositions.Middle
          });
        }
      }
    } else {
      dispatch(setQuestionIndex(questionIndex + 1));
      dispatch(resetQuestionStatuses());
      navigateTo('question');
    }
  }

  return (
    <Fragment>
      {openBrandDialog ? (
        <BrandVideoDialog
          onClose={handleCloseBrandDialog}
        />
      ) : null}
      {openAdvertDialog ? (
        <MidRollVideoDialog
          onClose={handleCloseAdvertDialog}
        />
      ) : null}
      {openInterstitialDialog ? (
        <InterstitialImageDialog
          onClose={handleCloseInterestialDialog}
        />
      ) : null}
    </Fragment>
  )
}

export default MediaPage;
